import DocumentV1FromShowApp from "documentV1/documentFromShow/App";
import { userTypeRouting } from "pages/utils";
import {
  type RouteObject,
} from "react-router";
import ShowCopyPage from "show/copy/app";
import { ShowEditAppForExternal, ShowEditAppForInternal } from "show/edit";
import { ShowFromWebfromApp } from "show/FromWebform/App";
import ShowListInternalApp from "show/list/app";
import ShowListExternalApp from "show/list_external/app";
import { LockShowsApp } from "show/lock/App";
import { ShowNewAppForExternal, ShowNewAppForInternal } from "show/new";

declare let viewModel: any;

export const showRoute: RouteObject = {
  path: "show",
  children: [{
    index: true,
    loader: () => viewModel,
    Component: userTypeRouting({
      internal: ShowListInternalApp,
      external: ShowListExternalApp,
    }),
  }, {
    path: "new",
    loader: () => viewModel,
    Component: userTypeRouting({
      internal: ShowNewAppForInternal,
      external: ShowNewAppForExternal,
    }),
  }, {
    path: ":key/edit",
    loader: () => viewModel,
    Component: userTypeRouting({
      internal: ShowEditAppForInternal,
      external: ShowEditAppForExternal,
    }),
  }, {
    path: ":key/copy",
    loader: () => viewModel,
    Component: ShowCopyPage,
  }, {
    path: ":key/fromwebform",
    loader: () => viewModel,
    Component: ShowFromWebfromApp,
  }, {
    path: ":key/invoice",
    loader: () => viewModel,
    Component: DocumentV1FromShowApp,
  }, {
    path: ":key/contract",
    loader: () => viewModel,
    Component: DocumentV1FromShowApp
  }, {
    path: ":key/quote",
    loader: () => viewModel,
    Component: DocumentV1FromShowApp
  }, {
    path: ":key/purchaseagreement",
    loader: () => viewModel,
    Component: DocumentV1FromShowApp
  }, {
    path: "lock",
    loader: () => viewModel,
    Component: LockShowsApp
  }]
};